export enum TipoAtividade {
  download = "download",
  upload = "upload",
  envioNotificacao = "EnvioNotificacao",
}